import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FaDownload } from "react-icons/fa";
import { downloadFile } from "../../utils/fileUtils";
import ActionButton from "./ActionButton";

const ExportButton = ({ variant = "circle" }) => {
  const history = useSelector((state) => state.history);
  const messages = useSelector((state) => state.messages);
  const viewer = useSelector((state) => state.viewer);
  const viewerLastUpdated = useSelector((state) => state.viewerLastUpdated);
  const [isDiagramLoaded, setIsDiagramLoaded] = useState(false);

  useEffect(() => {
    setIsDiagramLoaded(
      viewer?.getDefinitions()?.rootElements?.length > 0 || false
    );
  }, [viewer, viewerLastUpdated]);

  const downloadXMLandSVG = async () => {
    if (!viewer) return console.error("Viewer is not available");

    try {
      const { xml } = await viewer.saveXML({ format: true });
      downloadFile(xml, "current_diagram.bpmn", "application/xml");
      const { svg } = await viewer.saveSVG();
      downloadFile(svg, "current_diagram.svg", "image/svg+xml");
    } catch (err) {
      console.error("Error saving XML or SVG:", err);
    }
  };

  const downloadJSON = () => {
    let jsonData = history.entries[history.pointer]?.jsonData;
    if (jsonData && Object.keys(jsonData).length > 0) {
      downloadFile(jsonData, "current_diagram.json", "application/json");
    }
  };

  const downloadState = () => {
    downloadFile(
      { history, messages, localStorage: { ...localStorage }, sessionStorage: {...sessionStorage} },
      "session_state_importable.json",
      "application/json"
    );
  };

  const handleDownload = async () => {
    await downloadXMLandSVG();
    downloadJSON();
    downloadState();
  };

  return (
    <ActionButton
      icon={FaDownload}
      tooltip="Export"
      onClick={handleDownload}
      variant={variant}
      disabled={!isDiagramLoaded}
    />
  );
};

export default ExportButton;